<script setup lang="ts">
import type { RouteLocationRaw } from "#vue-router";

const currentYear = new Date().getFullYear();

const links: Array<{
  text: string;
  to: RouteLocationRaw;
  icon: string;
}> = [
  {
    text: "Kundeservice",
    to: { name: "kundeservice" },
    icon: "far:headphones",
  },
  {
    text: "Brukerinvolvering",
    to: { name: "brukerinvolvering" },
    icon: "far:users",
  },
  {
    text: "Nyhetsbrev",
    to: { name: "nyhetsbrev" },
    icon: "far:envelope",
  },
  {
    text: "Kjøpsbetingelser",
    to: { name: "kjopsbetingelser" },
    icon: "far:receipt",
  },
  {
    text: "Personvern og cookies",
    to: { name: "personvern" },
    icon: "far:shield-check",
  },
];
</script>

<template>
  <footer class="w-full bg-green-50 text-white">
    <UContainer class="flex flex-col gap-s pt-l pb-s tablet:gap-xs tablet:py-12">
      <nav class="flex justify-between">
        <ul class="flex flex-col gap-s tablet:flex-row tablet:gap-10">
          <li v-for="link in links" :key="link.text">
            <NuxtLink :to="link.to" class="flex items-center gap-xs text-sm leading-7! no-underline hover:underline tablet:gap-2xs">
              <UIcon :name="link.icon" size="1.5em" />
              {{ link.text }}
            </NuxtLink>
          </li>
        </ul>
        <LayoutSocial class="hidden tablet:inline-flex" />
      </nav>
      <hr class="text-green-30" />
      <div class="flex flex-wrap items-center justify-between gap-s tablet:justify-center">
        <p>Aschehoug&nbsp;&copy;&nbsp;{{ currentYear }}</p>
        <LayoutSocial class="tablet:hidden" />
      </div>
    </UContainer>
  </footer>
</template>
